import Language from '../Language';

export default new Language(
	'French',
	[
		'Janvier',
		'FÃ©vrier',
		'Mars',
		'Avril',
		'Mai',
		'Juin',
		'Juillet',
		'AoÃ»t',
		'Septembre',
		'Octobre',
		'Novembre',
		'DÃ©cembre'
	],
	['Janv.','FÃ©vr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juill.', 'AoÃ»t', 'Sept.', 'Oct.', 'Nov.', 'DÃ©c.'],
	['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
);
// eslint-disable-next-line
